var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { useMemo } from 'react';
import { useStoreContext } from '../../../components/Context';
import { setArrayValue, setTouched, setValue } from './actions';
import { getDraft, getError, getTouched, getValue } from './selectors';
// одно поле формы
export var useField = function (path) {
    var _a = useStoreContext(), state = _a[0], dispatch = _a[1];
    var field = {
        value: getValue(path, state),
        touched: getTouched(path, state),
        error: getError(path, state),
    };
    var helpers = useMemo(function () { return ({
        setValue: function (value, shouldValidate) { return dispatch(setValue({
            path: path,
            value: value,
            shouldValidate: shouldValidate,
        })); },
        setTouched: function (value, shouldValidate) {
            if (value === void 0) { value = true; }
            if (shouldValidate === void 0) { shouldValidate = true; }
            return dispatch(setTouched({
                path: path,
                value: value,
                shouldValidate: shouldValidate,
            }));
        },
    }); }, [dispatch, path]);
    return [field, helpers];
};
// вспомогательне функции для массива, пока что жестко прибиты к createDraftAddress
// потом можно будет сделать более универсально
var push = function (value) { return function (arr) { return arr.concat(value); }; };
var remove = function (index) { return function (arr) { return arr.filter(function (_, i) { return i !== index; }); }; };
var swap = function (from, to) { return function (arr) {
    var copy = __spreadArray([], arr);
    var a = copy[from];
    copy[from] = copy[to];
    copy[to] = a;
    return copy;
}; };
var clear = function (index, initValue) { return function (arr) { return arr.map(function (value, i) { return i === index
    ? initValue
    : value; }); }; };
// поле в виде массива, в данный момент это только route
export var useArrayField = function (path) {
    var _a = useStoreContext(), state = _a[0], dispatch = _a[1];
    var field = {
        value: getValue(path, state),
        touched: undefined,
        error: undefined,
    };
    var helpers = useMemo(function () { return ({
        push: function (value) {
            dispatch(setArrayValue({
                path: path,
                fn: push(value),
            }));
        },
        remove: function (index) {
            dispatch(setArrayValue({
                path: path,
                fn: remove(index),
            }));
        },
        swap: function (from, to) {
            dispatch(setArrayValue({
                path: path,
                fn: swap(from, to),
            }));
        },
        clear: function (index, value) {
            dispatch(setArrayValue({
                path: path,
                fn: clear(index, value),
            }));
        },
    }); }, [dispatch, path]);
    return [field, helpers];
};
export var useValues = function () {
    var state = useStoreContext()[0];
    return getDraft(state).values;
};
